import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mubiao",
  "use": "icon-mubiao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mubiao\"><path d=\"M921.6 0H0v1024h1024V0z m0 921.6H102.4V102.4h819.2z m-460.8-102.4h102.4v-153.6h153.6v-102.4h-153.6v-51.2h153.6V409.6h-153.6l102.4-204.8h-102.4l-51.2 102.4-51.2-102.4H358.4l102.4 204.8H307.2v102.4h153.6v51.2H307.2v102.4h153.6z\" fill=\"#ffffff\" p-id=\"5512\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol